export const STACKS_ECOSYSTEM = '39e67b1b-c4f9-403f-ae11-a2117a2bf590'

// for development use
// export const MUNDO_CRYPTO = '406107b8-4c20-4219-b72b-ce6d1c33f583'

export const MUNDO_CRYPTO = 'qq'



// WEBPACK FOOTER //
// ./src/constants/jobboards-ids.js